// extracted by mini-css-extract-plugin
module.exports = {"list":"VacancySpecifications_list__2g62h","narrow":"VacancySpecifications_narrow__EzBVN"};